/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement, useEffect } from "react"
import { Box, Heading, ResponsiveContext, Text } from "grommet"
import { Transition } from "../components/_shared_/transition"
import HeaderLayout from "../components/_shared_/header"
import { Container } from "../styles/components/container"
import GrommetWrapper from "../components/_shared_/grommet"
import SEO from "../components/_shared_/seo"
import Trail from "../components/_shared_/trail"
import { mainBlack, mainBlue } from "../styles/constants"
import FooterLayout from "../components/_shared_/footer"
import FadeIn from "../components/_shared_/fade-in"
import Cookies from "../components/_shared_/cookies"

interface GDPRProps {
  number: string
  title: string
  description: string | ReactElement
}

const GRPR: GDPRProps[] = [
  {
    number: `01`,
    title: `Identifikačné údaje a kontaktné údaje prevádzkovateľa`,
    description: (
      <Box>
        Prevádzkovateľ: SlovAcc, s. r. o.
        <br /> Sídlo: Ulica pri Čiernej vode 5446/44, 903 01 Senec
        <br />
        IČO: 51825724
        <br />
        Zapísaný: OR Okr. súdu Bratislava I, Oddiel: Sro, Vložka č.: 140212/B <br />
        Emailová adresa: info@slovacc.sk <br />
        Telefónne číslo: +421917828222
      </Box>
    ),
  },
  {
    number: `02`,
    title: `Kontaktné údaje zodpovednej osoby`,
    description: `Zodpovednú osobu možno kontaktovať prostredníctvom e-mailovej adresy info@slovacc.sk alebo písomne na adresu sídla prevádzkovateľa.`,
  },
  {
    number: `03`,
    title: `Účel spracúvania osobných údajov`,
    description: (
      <Box>
        <Box margin={{ bottom: `12px` }}>
          <b>Účelom je:</b>
        </Box>
        <ul>
          <li>
            uzatvorenie zmluvy o poskytovaní účtovných služieb a predzmluvné vzťahy, plnenie práv a povinností
            vyplývajúcich zo zmluvy o poskytovaní účtovných služieb,
          </li>
          <li>
            spracúvanie osobných údajov z dôvodu splnenia povinností podľa osobitných predpisov (daňové zákony a pod.)
          </li>
        </ul>
      </Box>
    ),
  },
  {
    number: `04`,
    title: `Právny základ spracúvania osobných údajov`,
    description: (
      <Box>
        <ul>
          <li>
            Právnym základom je ustanovenie § 13 ods. 1 písm. b) zákona o ochrane osobných údajov: spracúvanie osobných
            údajov je nevyhnutné na plnenie zmluvy, ktorej zmluvnou stranou je dotknutá osoba, alebo na vykonanie
            opatrenia pred uzatvorením zmluvy na základe žiadosti dotknutej osoby. Prevádzkovateľ týmto oznamuje
            zákazníkovi a záujemcovi o dodanie služieb ako dotknutej osobe (ďalej len „dotknutá osoba“), že v zmysle čl.
            6 ods.1 písm. c) Nariadenia, bude v procese uzatvorenia zmluvy o poskytovaní účtových služieb spracúvať
            osobné údaje bez súhlasu dotknutej osoby, keďže spracúvanie osobných údajov bude vykonávané prevádzkovateľom
            v rámci predzmluvných vzťahov a uzatvorenia zmluvy o poskytovaní účtovných služieb.
          </li>
          <li>
            Právnym základom je ustanovenie § 13 ods. 1 písm. c) zákona o ochrane osobných údajov: spracúvanie osobných
            údajov je nevyhnutné podľa osobitného predpisu. Prevádzkovateľ týmto oznamuje dotknutej osobe, že v zmysle
            čl. 6 ods.1 písm. c) Nariadenia, bude spracúvať osobné údaje bez súhlasu dotknutej osoby, keďže spracúvanie
            osobných údajov je nevyhnutné na splnenie zákonnej povinnosti prevádzkovateľa, ktorou je splnenie daňových
            povinností.
          </li>
        </ul>
      </Box>
    ),
  },
  {
    number: `05`,
    title: `Identifikácia príjemcu alebo kategóriu príjemcu`,
    description: (
      <Box>
        <Box margin={{ bottom: `12px` }}>
          Osobné údaje sa spracúvajú a uchovávajú tak dlho, ako to vyžaduje účel, na ktorý boli zhromaždené.
        </Box>
        <Box margin={{ bottom: `12px` }}>Z tohto dôvodu:</Box>
        <ul>
          <li>
            Kategórie príjemcov, ktorí spracúvajú osobné údaje sú: Externý účtovník, Poštový prepravca, Dodávateľ (pre
            účely vybavenia reklamácie)
          </li>
          <li>
            Štátne inštitúcie za účelom plnenia povinností prevádzkovateľa: Daňový úrad, orgán štátnej správy a verejnej
            moci na výkon kontroly a dozoru (Slovenská obchodná inšpekcia, Úrad na ochranu osobných údajov), exekútor,
            súd, orgán činný v trestnom konaní atď.
          </li>
        </ul>
      </Box>
    ),
  },
  {
    number: `06`,
    title: `Doba uchovávania osobných údajov`,
    description: `Doba uchovávania osobných údajov je určená zákonmi na uplatňovanie práv a povinností vyplývajúcich z uzavretej zmluvy o poskytovaní účtovných služieb; dlhšie spracúvanie osobných údajov je možné len výlučne na účel archivácie účtovných dokladov na základe osobitného predpisu.`,
  },
  {
    number: `07`,
    title: `Práva dotknutej osoby`,
    description: (
      <Box>
        Dotknutá osoba má právo:
        <ul>
          <li>
            <b>požadovať prístup k osobným údajom</b> týkajúcich sa dotknute osoby. Dotknutá osoba má právo vedieť
            zoznam osobných údajov, ktoré spracúvame.
          </li>
          <li>
            <b>na opravu osobných údajov.</b> Prevádzkovateľ prijal opatrenia, aby uchovával presné, úplné a aktuálne
            osobné údaje.
          </li>
          <li>
            <b>na vymazanie osobných údajov</b> (tzv. právo na zabudnutie). Dotknutá osoba môže požiadať o vymazanie jej
            osobných údajov, ak sú na to splnené zákonom uvedené dôvody, a to najmä: osobné údaje už nie sú potrebné na
            účel, na ktorý boli získané; súhlas bol odvolaný; osobné údaje sa spracúvali nezákonne, a pod. Žiadosti o
            výmaz osobných údajov nemusí byť vyhovené, pokiaľ je spracovanie osobných údajov potrebné na: splnenie
            zákonnej povinnosti; na účel archivácie, na účel historického výskumu alebo na štatistický účel, pokiaľ je
            pravdepodobné, že právo na výmaz by znemožnilo alebo závažným spôsobom sťažilo dosiahnutie cieľov takého
            spracúvania.
          </li>
          <li>
            <b>na obmedzenie spracúvania osobných údajov.</b>Dotknutá osoba môže pri splnení zákonných podmienok
            požiadať, aby sa prestali používať osobné údaje, a to najmä počas obdobia overenia správnosti osobných
            údajov, v prípade namietnutia správnosti osobných údajov; počas obdobia overenia, či prevádzkovateľ má
            relevantný účel spracúvania; počas obdobia overenia, či oprávnené záujmy prevažujú nad oprávnenými záujmami.
          </li>
          <li>
            <b>namietať spracúvanie osobných údajov. </b>Dotknutá osoba má právo namietať spracúvanie osobných údajov v
            prípade pochybností, či je na spracúvanie osobných údajov právny dôvod, príp. namietať spracúvanie osobných
            údajov, ktoré sa týkajú priameho marketingu vrátane profilovania v rozsahu, v akom súvisí s priamym
            marketingom.
          </li>
          <li>
            <b> na prenosnosť osobných údajov. </b>Dotknutá osoba má za určitých okolností právo požiadať o prenos
            osobných údajov, ktoré poskytla prevádzkovateľovi. Toto právo na prenosnosť sa týka len tých osobných
            údajov, ktoré boli poskytnuté na základe súhlasu alebo na základe zmluvy, ktorej je jednou zo zmluvných
            strán.
          </li>
          <li>
            <b>odvolať súhlas.</b>Dotknutá osoba má právo kedykoľvek odvolať súhlas v prípade, že sa osobné údaje
            spracúvajú na základe súhlasu. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania vychádzajúceho zo
            súhlasu pred jeho odvolaním.
          </li>
          <li>
            <b>podať návrh na začatie konania resp. sťažnosť na dozorný orgán.</b>Dotknutá osoba má právo podať návrh
            resp. sťažnosť na Úrad na ochranu osobných údajov Slovenskej republiky, https://dataprotection.gov.sk ,
            Hraničná 12, 820 07 Bratislava 27; tel. číslo: +421 /2/ 3231 3214; E-mail: statny.dozor@pdp.gov.sk. Dotknutá
            osoba môže požadovať výkon vyššie uvedených práv kedykoľvek, a to prostredníctvom emailu info@slovacc.sk
            alebo písomne na poštovú adresu sídla prevádzkovateľa. Prevádzkovateľ vybaví žiadosť dotknutej osoby v
            súvislosti s vyššie uvedenými právami v zákonných lehotách.
          </li>
        </ul>
      </Box>
    ),
  },
  {
    number: `08`,
    title: `Zákonná alebo zmluvná požiadavka`,
    description: `Dotknutá osoba je povinná poskytnúť osobné údaje na účel uvedený v tomto dokumente, v opačnom prípade nie je možné uzavrieť zmluvu poskytovaní účtovných služieb, o ktorú dotknutá osoba prejavila záujem a následne plniť práva a povinnosti vyplývajúce z uzatvorenej zmluvy o poskytovaní účtovných služieb pre prevádzkovateľa a dotknutú osobu. `,
  },
]

const GDPR: React.FunctionComponent = () => {
  useEffect(() => window.scrollTo(0, 0), [])
  return (
    <GrommetWrapper>
      <SEO title="Zásady ochrany osobných údajov" />
      <Cookies />
      <ResponsiveContext.Consumer>
        {(size: string): JSX.Element => (
          <>
            <HeaderLayout size={size} />
            <Transition>
              <Container>
                <Box justify="center" align="center" height="320px">
                  <Heading
                    margin={{
                      vertical: `0`,
                      horizontal: `0`,
                    }}
                    className="relative"
                    style={{ top: `70px` }}
                    size="medium"
                  >
                    {size !== `small` && <Trail text="Zásady ochrany osobných údajov" />}
                    {size === `small` && `Zásady ochrany osobných údajov`}
                  </Heading>
                </Box>
                <FadeIn>
                  {GRPR.map(({ number, title, description }: GDPRProps) => (
                    <Box key={number} margin={{ bottom: `24px` }}>
                      <Heading margin={{ bottom: `12px` }} size="large" color={mainBlue}>
                        {number}
                      </Heading>
                      <Text margin={{ vertical: `8px` }} size="xlarge" weight="bold" color={mainBlack}>
                        {title}
                      </Text>
                      <Text size="medium" color={mainBlack}>
                        {description}
                      </Text>
                    </Box>
                  ))}
                </FadeIn>
              </Container>
              <Container minHeight="auto" fluid>
                <FooterLayout size={size} />
              </Container>
            </Transition>
          </>
        )}
      </ResponsiveContext.Consumer>
    </GrommetWrapper>
  )
}

export default GDPR
